import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Stack,
  Chip,
  Switch,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Select,
  Box,
} from "@mui/material";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import SearchBar from "../../../components/SearchBar";

const impactRows = [
  {
    id: 1,
    module: "Free",
    lowLevel: "Level 1",
    mediumStatus: "Manual",
    impact: "Manual",
    guardrail: "Medium",
  },
  {
    id: 2,
    module: "Grow",
    lowLevel: "Level 2",
    mediumStatus: "Connected",
    impact: "Manual",
    guardrail: "Reg",
  },
  {
    id: 3,
    module: "Scale",
    lowLevel: "Level 2",
    mediumStatus: "Fully Autom.",
    impact: "Manual",
    guardrail: "Reg",
  },
  {
    id: 4,
    module: "Elite",
    lowLevel: "Level 3",
    mediumStatus: "Fully Autom.",
    impact: "Manual",
    guardrail: "Reg",
  },
];



const SubscriptionsHtmlTable: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="lt">
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </Box>
        </div>
     

      </div>

      {/* ================= IMPACT TABLE ================= */}
      <TableContainer component={Paper} className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No.</TableCell>
              <TableCell>Subscription</TableCell>
              <TableCell>Current Level</TableCell>
              <TableCell> Impact</TableCell>

            </TableRow>
          </TableHead>

          <TableBody>
            {impactRows.map((row, index) => (
              <TableRow key={row.id} hover>
                <TableCell>{index + 1}</TableCell>

                <TableCell>
                  <Typography fontWeight={500}>{row.module}</Typography>
                </TableCell>

                {/* LOW IMPACT */}
                {/* LOW IMPACT */}
                <TableCell>

                  <Select
                    value={row.lowLevel}
                    size="small"
                    sx={{
                      background: "#e3d8ff",
                      fontWeight: 500,
                      height: "32px",
                      ".MuiOutlinedInput-notchedOutline": { border: "none" }
                    }}
                  >
                    <MenuItem value="Level 1">Level 1</MenuItem>
                    <MenuItem value="Level 2">Level 2</MenuItem>
                    <MenuItem value="Level 3">Level 3</MenuItem>
                  </Select>

                </TableCell>

                {/* MEDIUM IMPACT */}
                <TableCell>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{
                      background: "#e8f5f0",
                      p: 1,
                      borderRadius: 3,
                      width: "fit-content",
                    }}
                  >
                    <CheckCircleIcon fontSize="small" color="success" />
                    <Chip
                      label={row.mediumStatus}
                      size="small"
                      sx={{ background: "#d7f3e8" }}
                    />
                    <Switch size="small" color="success" />
                  </Stack>
                </TableCell>

                {/* HIGH IMPACT */}

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* MENU */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem>Edit</MenuItem>
        <MenuItem>Disable</MenuItem>
        <MenuItem>View Details</MenuItem>
      </Menu>

    </div>
  );
};

export default SubscriptionsHtmlTable;
